/**
 * Offline Storage Service
 * Handles offline data storage and synchronization
 */

/**
 * Initialize offline storage
 */
export async function initializeOfflineStorage() {
  try {
    // Check if IndexedDB is available
    if (!('indexedDB' in window)) {
      console.warn('IndexedDB not available, offline storage disabled');
      return false;
    }

    console.log('✅ Offline storage initialized');
    return true;
  } catch (error) {
    console.error('Failed to initialize offline storage:', error);
    return false;
  }
}

/**
 * Store data offline
 */
export async function storeOfflineData(key, data) {
  try {
    localStorage.setItem(`kassie_offline_${key}`, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error('Failed to store offline data:', error);
    return false;
  }
}

/**
 * Get offline data
 */
export async function getOfflineData(key) {
  try {
    const data = localStorage.getItem(`kassie_offline_${key}`);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Failed to get offline data:', error);
    return null;
  }
}

/**
 * Clear offline data
 */
export async function clearOfflineData(key) {
  try {
    localStorage.removeItem(`kassie_offline_${key}`);
    return true;
  } catch (error) {
    console.error('Failed to clear offline data:', error);
    return false;
  }
}